// Application configuration
const config = {
  // API base URL, baked in at build time. Empty/unset = same-origin (production:
  // the frontend nginx proxies /api to the backend). Local dev sets it to
  // http://localhost:8000 in frontend/.env. Defaulting to '' (same-origin) rather
  // than localhost means a missing VITE_API_URL in prod can't point users at
  // their own machine.
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  odooUrl: import.meta.env.VITE_ODOO_URL || '', // Odoo base URL for deep-links (e.g. https://lamptwist.odoo.com)
};

export default config;
